import { UserPermission } from '../UserPermission';
import { Json } from '../Json';

export class LoginUserDto {
  username: string;
  applicationRoles: Json<string, UserPermission>;
  token?: string;

  constructor(username: string, applicationRoles: Json<string, UserPermission>, token?: string) {
    this.username = username;
    this.applicationRoles = applicationRoles;
    this.token = token;
  }
}
